import { configureStore } from '@reduxjs/toolkit';
import athkarEsabahReducer from './reducers/athkarEsabahSlice';
import athkarElmasaaReducer from './reducers/athkarElmasaaSlice';
import athkarAlnomSlice from './reducers/athkarAlnomSlice';

import themeSlice from './reducers/themeSlice';
import athkarEsalahSlice from './reducers/athkarEsalahSlice';
import werdAlthekrSlice from './reducers/werdAlthekrSlice';
import athkarMudafaSlice from './reducers/athkarMudafaSlice';


export const store = configureStore({
  reducer: {
    athkarEsabah: athkarEsabahReducer,
    athkarElmasaa: athkarElmasaaReducer,
    athkarElnom: athkarAlnomSlice,
    athkarEsalah: athkarEsalahSlice,
    werdAlthekr: werdAlthekrSlice,
    athkarMudafa: athkarMudafaSlice,
    theme: themeSlice,
  },
});
